import { apiPost } from '../api'

export const update_user = data => {
  return apiPost({
    endpoint: 'user/update_user',
    data: data
  })
}
